import React from "react";
import "./Select.scss";

import Icon_ from "../../../assets/icons/question.svg";

const Select = ({
    options = [],
    setValue,
    name,
    value = "", // aquí value es el código (string o number)
    className = "",
    icon,
    text,
    show,
    onClick,
}) => {
    const handleChange = (e) => {
        setValue(e.target.value); // Pasamos solo el código
    };

    return (
        <div className={`Select ${className}`}>
            {text && <span className="select-text">{text}</span>}
            <div className="select-congainer">
                <div className="select-con-img">
                    <img src={icon ? icon : Icon_} alt="" />
                </div>
                <select
                    value={value} // usamos directamente el código
                    onChange={handleChange}
                    name={name}
                    onClick={onClick}
                    className={`select-input ${show ? "error-color" : ""}`}
                >
                    <option value="" disabled></option>
                    {options.map((item) => (
                        <option key={item.id} value={item.id}>
                            {item.name}
                        </option>
                    ))}
                </select>
            </div>
        </div>
    );
};

export default Select;
